module.exports = '<svg width="43" height="32" viewBox="0 0 43 32"><path d="M42.053 14.005L30.477.965C30 .432 29.061 0 28.376 0H3.947C2.568 0 0 1.325 0 2.8v26.4C0 30.675 2.568 32 3.947 32h24.427c.688 0 1.624-.432 2.099-.965l11.579-13.072c.955-1.067.955-2.891.003-3.957zM24 16c0-2.944 2.389-5.333 5.333-5.333s5.333 2.389 5.333 5.333-2.389 5.333-5.333 5.333S24 18.944 24 16z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/tag-2.js
// module id = 1446
// module chunks = 14